import { Box, Typography } from '@mui/material'
import React from 'react';
import { string } from 'yup';

interface SlotStatusProps {
    // type?: "provided" | "notprovided" | "verified" | "notverified" | "completed" | "submitted" | "empaneled" | "notempaneled" | "scheduled" | "notsubmitted" | "plainnotjoined" | "inprogress" | "awaited" | "candidatenotjoined"  | "applied"  | "interviewschedule" 
    type: string
}

interface SlotModel {
    name: string;
    type: string;
    bgColor: string;
    color: string;
}

const data: SlotModel[] = [
    { name: "Provided", type: "provided", bgColor: "#E8F9F1", color: "#00C306" },
    { name: "Not Provided", type: "notprovided", bgColor: "#FAEEEE", color: "#FF050A" },
    { name: "Verified", type: "verified", bgColor: "#E8F9F1", color: "#4CAF50" },
    { name: "Not Verified", type: "notverified", bgColor: "#FAEEEE", color: "#FF050A" },
    { name: "Completed", type: "completed", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Interview Completed", type: "interviewcompleted", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Submitted", type: "submitted", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Empanelled", type: "empaneled", bgColor: "#DFF0D8", color: "#4CAF50" },
    { name: "Not Empanelled", type: "notempaneled", bgColor: "#FAEEEE", color: "#FF050A" },
    { name: "Scheduled", type: "scheduled", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Not Submitted", type: "notsubmitted", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Plain Not Joined", type: "plainnotjoined", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Inprogress", type: "inprogress", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Awaited", type: "awaited", bgColor: "rgba(255, 222, 222, 1)", color: "#000000" },
    { name: "Candidate Not Joined", type: "candidatenotjoined", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Scheduled", type: "scheduled", bgColor: "rgba(76, 175, 80, 0.1)", color: "#4CAF50" },
    { name: "Applied", type: "applied", bgColor: '#FCF8E3', color: "#202020" },
    { name: "Interview Scheduled", type: "interviewscheduled", bgColor: "rgba(217, 237, 247, 1)", color: "#000000" },
    { name: "Interview Re-scheduled", type: 'interviewrescheduled', bgColor: "#FAEEEE", color: "#000000" },
    { name: "Updated", type: "updated", bgColor: "(232, 249, 241, 1)", color: "#00C306" },
    { name: "Not Updated", type: "notupdated", bgColor: '#E5FFDB', color: "#00C306" },
    { name: "Map Eligibility", type: "mapeligibility", bgColor: "#fff", color: "#FB8B0E" },
    { name: "Eligible", type: "eligible", bgColor: '#E5FFDB', color: '#4FA143' },
    { name: "Not Eligible", type: 'noteligible', bgColor: '#FFE0DB', color: '#F64D47' },
    { name: "Booked", type: "booked", bgColor: "#C2FFDB", color: "#3A8E5C" },
    { name: "Available", type: "available", bgColor: "#ADDFFF", color: "#1C698D" },
    { name: "Not Available", type: "notavailable", bgColor: "#FFF4DB", color: "#E29B4D" },
    { name: "Rescheduling in Progress", type: "reschedulinginprogress", bgColor: "#ADDFFF", color: "#1C698D" },
    { name: "Pending", type: "pending", bgColor: "#FAEEEE", color: "#FF050A" },
    { name: "Open", type: "open", bgColor: "#E8F9F1", color: "#00C306" },
    { name: "Closed", type: "closed", bgColor: "#FAEEEE", color: "#FF050A" },
    { name: "Query Raised", type: "queryraised", bgColor: "#C2FFDB", color: "#3A8E5C" },
    { name: "View Eligibility",type:'viewEligiblity',bgColor:'#fff',color:'#034ea2'},
    { name: "Not Applicable", type: `notapplicable`, bgColor: '#FCF8E3', color: "#202020" },
    { name: "Rescheduling Cancelled", type: `rescheduling_cancel`, bgColor: '#FFCCCC', color: "#202020" },
    { name: "Rescheduling on Hold", type: `rescheduling_hold`, bgColor: '#F0D98C', color: "#202020" },
    { name:"Interview on Hold", type:'interview_hold', bgColor: '#FFCCCC', color: "#202020" },
    { name: "Reschedule Failed", type: `reschedule_failed`, bgColor:"#FF050A", color:"#fff1f1ff"},
];


const SlotStatus: React.FC<SlotStatusProps> = ({ type }) => {
    return (
        <>
            {data?.map((item: SlotModel, index: number) => (
                <React.Fragment key={index}>
                    {type === item?.type && (
                        <Box
                            display="inline-flex"
                            alignItems="center"
                            justifyContent="center"
                            padding="8px 16px"
                            borderRadius="16px"
                            width="max-content"
                            bgcolor={item?.bgColor}
                        >
                            <Typography variant="body2" color={item?.color}>
                                {item?.name}
                            </Typography>
                        </Box>
                    )}</React.Fragment>
            ))}
        </>
    )
}


export default SlotStatus;